export enum RolesType {
  Admin = 'Admin',
  CustomerAdmin = 'CustomerAdmin',
  BuyerAdmin = 'BuyerAdmin',
  Buyer = 'Buyer',
  BuyerViewer = 'BuyerViewer',
  Analyst = 'Analyst',
  Requester = 'Requester',
}
